// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gymContainer {
  width: 100%;
  margin: 20px auto 0px auto;
  padding: 0 6%;
}
.band_img_div_gym {
  width: 100%;
}

.band_img_div_gym > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gymContainer > h1 {
  color: #000;
  margin-top: 50px;
  font-size: clamp(18px, 4vw, 20px) !important;
  font-weight: 600;
}
.gymContainer > p {
  color: #000;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-style: normal;
  font-family: lightThicker !important;
  margin: 10px auto 30px auto !important; 
}
.gymContainer > p > span {
  color: #ba1e24;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 600;
}
.gymContainer > ul {
  display: flex;
  flex-direction: column;
}
.gymContainer > ul > li {
  color: #000;
  font-family: lightThicker !important;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 70px;
  margin-left: -10px;
  line-height: 150%;
}
.gymContainer > ul > li::marker {
  color: #ba1e24 !important;
}
.lotmore {
  margin-top: 10px;
  color: #ba1e24 !important;
  font-size: clamp(25px, 4vw, 32px) !important;
  font-family: lightThicker !important;
}
.gymContainerDark {
  padding: 50px 0px;
  width: 80%;
  margin: 20px auto 0px auto;
}
.cardsContainer {
  padding: 0px 0px 50px 0px;
  width: 80%;
  margin: 20px auto 0px auto;
}
.gymContainerDark > h1 {
  color: #fff;
  font-size: clamp(30px, 4vw, 36px);
}
.gymBorder {
  width: 250px;
  border-bottom: 10px solid #ba1e24;
}
.gymContainerDark > p {
  margin-top: 30px;
  margin-bottom: 10px;
  font-family: lightThicker !important;
  font-size: 20px;
  font-weight: 400;
}
.gymContainerDark > select {
  font-size: 20px !important;
  width: 450px !important;
  color: #fff !important;
  border: transparent !important;
  border-bottom: 1px solid #fff !important;
  background-color: #262626 !important;
  padding-left: 0px !important;
}
.gymCard {
  width: 350px;
  background-color: #1e1e1e;
  padding: 15px;
  color: #fff;
  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);
}
.gymCard > h1 {
  font-size: 20px;
  color: #fff !important;
  margin: 20px 0px 0px 0px;
}
.gymCard > p {
  font-family: lightThicker !important;
  font-size: 14px;
}
.gymCard > img {
  width: 100%;
}
.gymCard > button {
  width: 100%;
  color: #fff;
  padding: 10px;
  justify-content: center;
  align-items: center;
  background-color: #ba1e24;
  border: none;
  display: none;
  transition: opacity 0.3s ease; /* Add transition effect */
}
.gymCard:hover button {
  display: block !important;
}
.gymCard:hover p {
  display: none !important;
}
.gymCard > div {
  display: flex;
}
.gymCard > div > h1 {
  font-size: 20px;
  text-decoration: underline;
  color: #fff;
}

.gym_form_header {
  width: 100%;
  padding: 0 120px;
}

.gym_form_header > p:first-child {
  color: #BA1E24;
font-family: "Thicker";
font-size: 44px;
font-style: normal;
font-weight: 400;
line-height: 126.6%; /* 55.704px */
text-transform: uppercase;
padding: 0 !important;
margin: 0 !important;
}

.gym_form_header > p:last-child {
  color: #000;
font-family: "lightThicker";
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 30px !important;
padding: 0 !important;
margin: 0 !important;
}




@media screen and (max-width: 1800px) {

  .gym_form_header {
    padding: 0 5% !important;
  }
  
  .gym_form_header > p:first-child {
  font-size: 44px;
  }
  
  .gym_form_header > p:last-child {
  font-size: 20px;
  }


}










@media screen and (max-width: 1400px) {

  .gymContainer {
    padding: 0 80px;
  }

  .gymContainer > ul > li {
    margin-right: 40px;
  }

    .gym_form_header {
      padding: 0 80px !important;
    }
    
    .gym_form_header > p:first-child {
    font-size: 44px;
    line-height: 126.6%; /* 55.704px */
    }
    
    .gym_form_header > p:last-child {
    font-size: 20px;
    line-height: 50px; /* 250% */
    }
}
@media screen and (max-width: 1200px) {
  .gymContainer {
    padding: 0 40px;
  }
  .gymContainer > ul {
    display: block;
  }

  .gym_form_header {
    padding: 0 60px !important;
  }
  
  .gym_form_header > p:first-child {
  font-size: 44px;
  line-height: 126.6%; /* 55.704px */
  }
  
  .gym_form_header > p:last-child {
  font-size: 20px;
  line-height: 30px; /* 250% */
  }
}


@media screen and (max-width: 1024px) {

  .gymContainer {
    padding: 0 40px;
  }

  .gym_form_header {
    padding: 0 40px !important;
  }
  .band_img_div_gym {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 0 20px;
   }
   
   .band_img_div_gym > img {
     width: 180%;
     height: 50px;
   }
}



@media screen and (max-width: 800px) {

  .gymContainer {
    padding: 0 30px;
  }

  .gym_form_header {
    padding: 0 30px !important;
  }
  
  .gym_form_header > p:first-child {
  font-size: 44px;
  line-height: 126.6%; /* 55.704px */
  }
  
  .gym_form_header > p:last-child {
  font-size: 20px;
  line-height: 30px; /* 250% */
  }
}


@media screen and (max-width: 600px) {
  .band_img_div_gym {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div_gym > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }
  .gymContainer {
    padding: 0 24px;
  }

  .gymContainer > h1 {
    margin-top: 20px;
  }
  .gymContainer > ul {
    margin-top: 20px;
  }

  .gymContainer > ul > li {
  margin-top: 2px;
  margin-bottom: 2px;
  }

  .gymContainerDark {
    padding: 20px 0px;
  }
  .gymContainerDark > select {
    width: 300px !important;
  }
  .lotmore {
    margin-top: 20px;
  }
  .gymContainer > p {
    margin: 25px auto !important;
  }
  .gymCard {
    width: 300px;
  }


  .gym_form_header {
    padding: 0 24px !important;
  }
  
  .gym_form_header > p:first-child {
  font-size: 24px;
  line-height: 126.6%; /* 55.704px */
  }
  
  .gym_form_header > p:last-child {
  font-size: 18px;
  line-height: 24px; /* 250% */
  }
}







@media screen and (max-width: 450px) {

  .gymContainer {
    padding: 0 16px;
  }

  .gym_form_header {
    padding: 0 16px !important;
  }
  
  .gym_form_header > p:first-child {
  font-size: 22px;
  line-height: 126.6%; /* 55.704px */
  }
  
  .gym_form_header > p:last-child {
  font-size: 16px;
  line-height: 24px; /* 250% */
  }


}`, "",{"version":3,"sources":["webpack://./src/components/gym/gym.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,6BAA6B,EAAE,0BAA0B;AAC3D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB,EAAE,aAAa;AAClC,yBAAyB;AACzB,qBAAqB;AACrB,oBAAoB;AACpB;;AAEA;EACE,WAAW;AACb,2BAA2B;AAC3B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,4BAA4B;AAC5B,qBAAqB;AACrB,oBAAoB;AACpB;;;;;AAKA;;EAEE;IACE,wBAAwB;EAC1B;;EAEA;EACA,eAAe;EACf;;EAEA;EACA,eAAe;EACf;;;AAGF;;;;;;;;;;;AAWA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;IAEE;MACE,0BAA0B;IAC5B;;IAEA;IACA,eAAe;IACf,mBAAmB,EAAE,aAAa;IAClC;;IAEA;IACA,eAAe;IACf,iBAAiB,EAAE,SAAS;IAC5B;AACJ;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;EACA,eAAe;EACf,mBAAmB,EAAE,aAAa;EAClC;;EAEA;EACA,eAAe;EACf,iBAAiB,EAAE,SAAS;EAC5B;AACF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;GAChB;;GAEA;KACE,WAAW;KACX,YAAY;GACd;AACH;;;;AAIA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;EACA,eAAe;EACf,mBAAmB,EAAE,aAAa;EAClC;;EAEA;EACA,eAAe;EACf,iBAAiB,EAAE,SAAS;EAC5B;AACF;;;AAGA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;EACD;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;EACA,eAAe;EACf,kBAAkB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;;;EAGA;IACE,0BAA0B;EAC5B;;EAEA;EACA,eAAe;EACf,mBAAmB,EAAE,aAAa;EAClC;;EAEA;EACA,eAAe;EACf,iBAAiB,EAAE,SAAS;EAC5B;AACF;;;;;;;;AAQA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;EACA,eAAe;EACf,mBAAmB,EAAE,aAAa;EAClC;;EAEA;EACA,eAAe;EACf,iBAAiB,EAAE,SAAS;EAC5B;;;AAGF","sourcesContent":[".gymContainer {\n  width: 100%;\n  margin: 20px auto 0px auto;\n  padding: 0 6%;\n}\n.band_img_div_gym {\n  width: 100%;\n}\n\n.band_img_div_gym > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.gymContainer > h1 {\n  color: #000;\n  margin-top: 50px;\n  font-size: clamp(18px, 4vw, 20px) !important;\n  font-weight: 600;\n}\n.gymContainer > p {\n  color: #000;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-style: normal;\n  font-family: lightThicker !important;\n  margin: 10px auto 30px auto !important; \n}\n.gymContainer > p > span {\n  color: #ba1e24;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 600;\n}\n.gymContainer > ul {\n  display: flex;\n  flex-direction: column;\n}\n.gymContainer > ul > li {\n  color: #000;\n  font-family: lightThicker !important;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 400;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  margin-right: 70px;\n  margin-left: -10px;\n  line-height: 150%;\n}\n.gymContainer > ul > li::marker {\n  color: #ba1e24 !important;\n}\n.lotmore {\n  margin-top: 10px;\n  color: #ba1e24 !important;\n  font-size: clamp(25px, 4vw, 32px) !important;\n  font-family: lightThicker !important;\n}\n.gymContainerDark {\n  padding: 50px 0px;\n  width: 80%;\n  margin: 20px auto 0px auto;\n}\n.cardsContainer {\n  padding: 0px 0px 50px 0px;\n  width: 80%;\n  margin: 20px auto 0px auto;\n}\n.gymContainerDark > h1 {\n  color: #fff;\n  font-size: clamp(30px, 4vw, 36px);\n}\n.gymBorder {\n  width: 250px;\n  border-bottom: 10px solid #ba1e24;\n}\n.gymContainerDark > p {\n  margin-top: 30px;\n  margin-bottom: 10px;\n  font-family: lightThicker !important;\n  font-size: 20px;\n  font-weight: 400;\n}\n.gymContainerDark > select {\n  font-size: 20px !important;\n  width: 450px !important;\n  color: #fff !important;\n  border: transparent !important;\n  border-bottom: 1px solid #fff !important;\n  background-color: #262626 !important;\n  padding-left: 0px !important;\n}\n.gymCard {\n  width: 350px;\n  background-color: #1e1e1e;\n  padding: 15px;\n  color: #fff;\n  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);\n}\n.gymCard > h1 {\n  font-size: 20px;\n  color: #fff !important;\n  margin: 20px 0px 0px 0px;\n}\n.gymCard > p {\n  font-family: lightThicker !important;\n  font-size: 14px;\n}\n.gymCard > img {\n  width: 100%;\n}\n.gymCard > button {\n  width: 100%;\n  color: #fff;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  background-color: #ba1e24;\n  border: none;\n  display: none;\n  transition: opacity 0.3s ease; /* Add transition effect */\n}\n.gymCard:hover button {\n  display: block !important;\n}\n.gymCard:hover p {\n  display: none !important;\n}\n.gymCard > div {\n  display: flex;\n}\n.gymCard > div > h1 {\n  font-size: 20px;\n  text-decoration: underline;\n  color: #fff;\n}\n\n.gym_form_header {\n  width: 100%;\n  padding: 0 120px;\n}\n\n.gym_form_header > p:first-child {\n  color: #BA1E24;\nfont-family: \"Thicker\";\nfont-size: 44px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 126.6%; /* 55.704px */\ntext-transform: uppercase;\npadding: 0 !important;\nmargin: 0 !important;\n}\n\n.gym_form_header > p:last-child {\n  color: #000;\nfont-family: \"lightThicker\";\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 30px !important;\npadding: 0 !important;\nmargin: 0 !important;\n}\n\n\n\n\n@media screen and (max-width: 1800px) {\n\n  .gym_form_header {\n    padding: 0 5% !important;\n  }\n  \n  .gym_form_header > p:first-child {\n  font-size: 44px;\n  }\n  \n  .gym_form_header > p:last-child {\n  font-size: 20px;\n  }\n\n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1400px) {\n\n  .gymContainer {\n    padding: 0 80px;\n  }\n\n  .gymContainer > ul > li {\n    margin-right: 40px;\n  }\n\n    .gym_form_header {\n      padding: 0 80px !important;\n    }\n    \n    .gym_form_header > p:first-child {\n    font-size: 44px;\n    line-height: 126.6%; /* 55.704px */\n    }\n    \n    .gym_form_header > p:last-child {\n    font-size: 20px;\n    line-height: 50px; /* 250% */\n    }\n}\n@media screen and (max-width: 1200px) {\n  .gymContainer {\n    padding: 0 40px;\n  }\n  .gymContainer > ul {\n    display: block;\n  }\n\n  .gym_form_header {\n    padding: 0 60px !important;\n  }\n  \n  .gym_form_header > p:first-child {\n  font-size: 44px;\n  line-height: 126.6%; /* 55.704px */\n  }\n  \n  .gym_form_header > p:last-child {\n  font-size: 20px;\n  line-height: 30px; /* 250% */\n  }\n}\n\n\n@media screen and (max-width: 1024px) {\n\n  .gymContainer {\n    padding: 0 40px;\n  }\n\n  .gym_form_header {\n    padding: 0 40px !important;\n  }\n  .band_img_div_gym {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    padding: 0 20px;\n   }\n   \n   .band_img_div_gym > img {\n     width: 180%;\n     height: 50px;\n   }\n}\n\n\n\n@media screen and (max-width: 800px) {\n\n  .gymContainer {\n    padding: 0 30px;\n  }\n\n  .gym_form_header {\n    padding: 0 30px !important;\n  }\n  \n  .gym_form_header > p:first-child {\n  font-size: 44px;\n  line-height: 126.6%; /* 55.704px */\n  }\n  \n  .gym_form_header > p:last-child {\n  font-size: 20px;\n  line-height: 30px; /* 250% */\n  }\n}\n\n\n@media screen and (max-width: 600px) {\n  .band_img_div_gym {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div_gym > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n  .gymContainer {\n    padding: 0 24px;\n  }\n\n  .gymContainer > h1 {\n    margin-top: 20px;\n  }\n  .gymContainer > ul {\n    margin-top: 20px;\n  }\n\n  .gymContainer > ul > li {\n  margin-top: 2px;\n  margin-bottom: 2px;\n  }\n\n  .gymContainerDark {\n    padding: 20px 0px;\n  }\n  .gymContainerDark > select {\n    width: 300px !important;\n  }\n  .lotmore {\n    margin-top: 20px;\n  }\n  .gymContainer > p {\n    margin: 25px auto !important;\n  }\n  .gymCard {\n    width: 300px;\n  }\n\n\n  .gym_form_header {\n    padding: 0 24px !important;\n  }\n  \n  .gym_form_header > p:first-child {\n  font-size: 24px;\n  line-height: 126.6%; /* 55.704px */\n  }\n  \n  .gym_form_header > p:last-child {\n  font-size: 18px;\n  line-height: 24px; /* 250% */\n  }\n}\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .gymContainer {\n    padding: 0 16px;\n  }\n\n  .gym_form_header {\n    padding: 0 16px !important;\n  }\n  \n  .gym_form_header > p:first-child {\n  font-size: 22px;\n  line-height: 126.6%; /* 55.704px */\n  }\n  \n  .gym_form_header > p:last-child {\n  font-size: 16px;\n  line-height: 24px; /* 250% */\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
